import React, { FC, ReactNode } from "react";
import { useScript } from "usehooks-ts";
import { RecurlyProvider, Elements } from "@recurly/react-recurly";
import { captureException } from "@sentry/react";
import { FieldNames, RECURLY_JS_URL } from "../../constants";
import { config } from "../../../../../config";
import { Spinner } from "../../../../Atoms/Spinner/Spinner";

const RecurlyWrapper: FC<React.PropsWithChildren<{ children: ReactNode }>> = ({
  children,
}) => {
  const status = useScript(RECURLY_JS_URL, { id: "recurly" });

  if (status === "error") {
    captureException("Recurly script failed to load");
  }

  if (status !== "ready") {
    return <Spinner />;
  }

  return (
    <RecurlyProvider
      publicKey={config.recurlyToken}
      required={[FieldNames.cvv, FieldNames.postalCode]}
    >
      <Elements>{children}</Elements>
    </RecurlyProvider>
  );
};

export default RecurlyWrapper;
